export default {
    getPrivilegeFromInMem(state) {
        return state.allPrivileges;
    },
    getActionListFromInMem(state) {
        return state.enabledActions;
    }
};